export default "<div id=\"swagger-ui\"></div>\n"